import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { authClient } from "@/lib/auth/auth-client";
import { getMyRoles } from "@/server/auth-access.functions";
import { ownsListingFn } from "./-provider.dashboard.functions";

export const Route = createFileRoute("/provider/dashboard")({
  component: ProviderDashboardGate,
});

function ProviderDashboardGate() {
  const navigate = useNavigate();
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: session } = await authClient.getSession();
      const user = session?.user;
      if (cancelled) return;
      if (!user) { navigate({ to: "/login/provider" }); return; }
      const roles = await getMyRoles();
      const hasListing = await ownsListingFn();
      let ok = roles.includes("doctor") || roles.includes("admin") || hasListing;
      if (cancelled) return;
      if (!ok) {
        setDenied(true);
        setTimeout(() => navigate({ to: "/login/provider" }), 1800);
        return;
      }
      // Zero listings → new-listing form (pick plan + create), never the empty dashboard.
      if (!hasListing) {
        navigate({ to: "/dashboard/new-listing", search: {} as any });
        return;
      }
      navigate({ to: "/dashboard/doctor", search: { billing: undefined, pid: undefined } as any });
    })();
    return () => { cancelled = true; };
  }, [navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground gap-2 px-4 text-center">
      {denied ? <p className="text-sm max-w-sm">This account does not have provider access. Please claim or create a provider profile first.</p>
        : (<><Loader2 className="h-4 w-4 animate-spin" /> Verifying provider access…</>)}
    </div>
  );
}
